import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal",
  tabindex: "-1",
  id: "copiarServicoModal"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header d-flex align-items-start pb-3\"><div class=\"row w-75\"><div class=\"col-12 d-flex\"><h3 class=\"card-title d-flex align-items-start flex-column\"><p class=\"card-label fw-bolder fs-4 mb-1\">Copiar serviços</p></h3></div></div><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div>", 1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 d-flex flex-column mb-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Selecione a concessionária", -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 d-flex flex-column mb-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Selecione o(s) serviço(s):", -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12 mb-6" }
const _hoisted_14 = ["data-kt-indicator"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Copiar serviço ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" })
], -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            ref: "ruleFormRef",
            model: $setup.form,
            rules: $setup.rules,
            class: "demo-ruleForm"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_el_form_item, { prop: "codConcessionariaAntigo" }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_el_select, {
                        class: "w-100",
                        modelValue: $setup.form.codConcessionariaAntigo,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.codConcessionariaAntigo) = $event)),
                        filterable: "",
                        placeholder: "Selecionar concessionária",
                        clearable: false,
                        "no-match-text": "Nenhuma concessionária foi encontrada",
                        "no-data-text": "Nenhuma concessionária foi encontrada",
                        onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.listaServicos()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.optionsConcessionaria, (concessionaria, i) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: i,
                              label: concessionaria.nomeFantasia,
                              value: concessionaria.codConcessionaria
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])), [
                        [_directive_loading, $setup.loading]
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_el_form_item, { prop: "codServicos" }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_el_select, {
                        modelValue: $setup.form.codServicos,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.codServicos) = $event)),
                        filterable: "",
                        placeholder: "Todos",
                        multiple: "",
                        "reserve-keyword": "",
                        clearable: true,
                        class: "w-100",
                        "no-match-text": "Nenhum serviço foi encontrado",
                        disabled: !$setup.form.codConcessionariaAntigo || $setup.allService == true ,
                        "no-data-text": "Nenhum serviço foi encontrado"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.optionsServicos, (servico, i) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: i,
                              label: servico.nome,
                              value: servico.codServico,
                              class: "w-100 cor_texto_1"
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])), [
                        [_directive_loading, $setup.loadingServico]
                      ]),
                      _createVNode(_component_el_checkbox, {
                        disabled: !$setup.form.codConcessionariaAntigo,
                        modelValue: $setup.allService,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.allService) = $event)),
                        label: "Todos servicos",
                        size: "large"
                      }, null, 8, ["disabled", "modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    type: "button",
                    style: {"height":"32px","border-top-left-radius":"0","border-bottom-left-radius":"0"},
                    class: _normalizeClass(["w-100 btn btn-sm btn-icon background_btn_1_opct btn-sm", {disabled: $setup.loadingButton}]),
                    "data-kt-indicator": $setup.loadingButton ? 'on' : 'off',
                    id: "kt_button_9",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.submitForm($setup.ruleFormRef)))
                  }, _hoisted_17, 10, _hoisted_14)
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ]))
}